export default __webpack_public_path__ + "static/hero-8ee2452871f89859006700a2daa7ff3e.jpg";